import { transparentize } from 'polished';

const colors = {
  brand: '#70A002',
  black: '#2A3234',
  lightGrey: '#CACCCC',
  grey: '#6D7278',
  info: '#2D9CDB',
};

export const designTokens = {
  /*
      Each media feature expression must be surrounded by parentheses,
      so we need to get rif off extra parentheses for kiosk, iPadKiosk and largeScreenKiosk.
      Now we can use for all breakpoints @media (${breakpoint})
    */
  breakpoint: {
    mobile: 'max-width: 575px',
    iPadKiosk: 'height: 1024px) and (width: 1366px',
    largeScreenKiosk: 'max-height: 1920px) and (orientation: portrait) and (width: 1080px',
    kiosk: 'height: 1024px) and (width: 1366px), (max-height: 1920px) and (orientation: portrait) and (width: 1080px',
    tablet: 'min-width: 576px',
    tabletLarge: 'min-width: 768px',
    desktop: 'min-width: 992px',
    desktopLarge: 'min-width: 1200px',
    wide: 'min-width: 1440px',
    extraWide: 'min-width: 1920px',
  },

  fontSize: {
    xxxl: '32px',
    xxl: '24px',
    xl: '20px',
    lg: '18px',
    md: '16px',
    sm: '14px',
    xs: '12px',
  },

  margins: {
    xxl: '32px',
    xl: '24px',
    lg: '18px',
    md: '16px',
    sm: '12px',
    xs: '8px',
  },

  fontWeight: {
    light: '300',
    regular: '400',
    medium: '500',
    bold: '700',
  },

  lineHeight: 1.16,

  borderRadius: {
    small: '4px',
    medium: '8px',
    large: '16px',
    ellipse: '100px',
    circle: '50%',
  },

  boxShadow: {
    small: `0 2px 4px ${transparentize(0.75, colors.grey)}`,
    medium: `0 8px 12px ${transparentize(0.85, colors.grey)}`,
    large: `0 15px 30px ${transparentize(0.25, colors.grey)}`,
    center: `0 0 20px ${transparentize(0.7, colors.grey)}`,
    focus: `0px 0px 0 3px ${transparentize(0.5, colors.info)}`,
    inset: `inset 0 4px 6px -2px ${transparentize(0.25, colors.grey)}`,
  },

  stroke: {
    brand: `1px solid ${colors.brand}`,
    dashed: `2px dashed ${colors.brand}`,
    default: `1px solid ${colors.grey}`,
    light: `1px solid ${colors.lightGrey}`,
    success: '1px solid #27AE60',
    error: '1px solid #EB5757',
  },

  color: {
    brand: colors.brand,
    black: colors.black,
    grey: colors.grey,
    lightGrey: colors.lightGrey,
    lighterGrey: '#F7F9FB',
    white: '#FFFFFF',
    success: '#27AE60',
    danger: '#EB5757',
    warning: '#F2C94C',
    info: colors.info,
    nutrition: {
      fats: '#25A7C3',
      carbs: '#3EC484',
      proteins: '#E4C834',
    },
    loyalty: {
      logo: '',
      icon: '',
      description: '',
      backgroundLogo: '',
    },
  },

  motion: {
    transition: 'all 0.25s ease-in-out',
  },

  positioning: {
    modal: 9999,
    modalOverlay: 9998,
    statusBar: 9997,
    header: 9996,
    footer: 9995,
    verticalHeader: 9994,
    a11yButton: 9993,
    welcomeBanner: 9992,
  },

  favicon: [
    'https://www.vitamojo.com/wp-content/themes/assemble/dist/img/favicons/favicon-16x16.png',
    'https://www.vitamojo.com/wp-content/uploads/cropped-Favicon-150x150-1-32x32.png',
    'https://www.vitamojo.com/wp-content/themes/assemble/dist/img/favicons/apple-touch-icon.png',
  ],

  logo: {
    size: 60,
    image: 'https://s3.vitamojo.com/static/vm-logo.svg',
    imageSm: 'https://s3.vitamojo.com/static/logo-sm.svg',
    copyrightImage: 'https://s3.vitamojo.com/static/newvmos.svg',
    copyrightImageWhite: 'https://s3.vitamojo.com/static/newvmoswhite.svg',
    imageBtn: '',
  },

  typography: {
    fonts: [], // controls external font imports
    /* Example:
      fonts: [
        {
          '@font-family': {
            src: 'url("<your-woff-font-url-here>") format("woff")'
            fontWeight: 'normal',
            fontFamily: 'MyFunkyFont'
          }
        }
      ]
    */

    fontFamilies: ['Roboto', 'Helvetica'], // controls fonts used, prioritized left to right as used in CSS font-family
    secondaryFontFamily: '',
  },

  constants: {
    headerHeight: '64px',
    footerHeight: '74px',
    largeFooterHeight: '120px',
  },
};

export const designTokensKiosk = {
  fontSize: {
    xxl: '32px',
    xl: '24px',
    lg: '20px',
    md: '18px',
    sm: '16px',
    xs: '14px',
  },

  constants: {
    headerHeight: '90px',
    footerHeight: '90px',
  },
};

export const designTokensLargeScreenKiosk = {
  constants: {
    headerHeight: '90px',
    footerHeight: '136px',
  },
};

export const designTokensMobile = {
  constants: {
    headerHeight: '48px',
  },
};
